import store from '../store/store';
import { firebase } from '../config/firebase.client';
import { get, onValue, push } from "firebase/database";
import { IAddBookingObjType, ISettingsType } from '../types';
import { RequestPushMsg } from '../other/NotificationFunctions';
import { CLEAR_BOOKING, CONFIRM_BOOKING, CONFIRM_BOOKING_FAILED, CONFIRM_BOOKING_SUCCESS } from "../store/types";

export const formatBookingObject = async (bookingData: IAddBookingObjType, settings: ISettingsType) => {

    if (!bookingData || !bookingData.pickup || !bookingData.pickup.coords || !bookingData.drop || !bookingData.drop.coords || !bookingData.carDetails || !bookingData.userDetails) return

    const c = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'
    const reference = [...Array(6)].map(_ => c[~~(Math.random() * c.length)]).join('');

    let today = new Date().getTime();


    let pickUp = { lat: bookingData.pickup.coords.lat, lng: bookingData.pickup.coords.lng, add: bookingData.pickup.description };
    let drop = { lat: bookingData.drop.coords.lat, lng: bookingData.drop.coords.lng, add: bookingData.drop.description };

    let coords = [{ latitude: pickUp.lat, longitude: pickUp.lng }];


    if (bookingData.drop.waypoints && Array.isArray(bookingData.drop.waypoints)) {
        bookingData.drop.waypoints.forEach((waypoint: any) => {
            if (waypoint.lat && waypoint.lng) {
                coords.push({
                    latitude: waypoint.lat,
                    longitude: waypoint.lng
                });
            } else if (waypoint.coords) {
                coords.push({
                    latitude: waypoint.coords.lat,
                    longitude: waypoint.coords.lng
                });
            }
        });
    } else if (bookingData.drop.waypointsStr) {
        if (bookingData.drop.waypointsStr.includes("|")) {

            bookingData.drop.waypointsStr.split("|").forEach((point: any) => {
                let lat = point.split(',')[0];
                let lng = point.split(',')[1];
                coords.push({ latitude: lat, longitude: lng });
            });
        } else {
            let lat = bookingData.drop.waypointsStr.split(',')[0];
            let lng = bookingData.drop.waypointsStr.split(',')[1];
            coords.push({ latitude: Number(lat), longitude: Number(lng) });
        }
    }

    var otp;
    if (bookingData?.settings?.otp_secure)
        otp = Math.floor(Math.random() * 90000) + 10000;
    else {
        otp = false;
    }

    const isCashSubPayment = bookingData.payment_mode == "driver_pix" || bookingData.payment_mode == "driver_credit_card" || bookingData.payment_mode == "driver_debit_card"

    return {
        otp: otp,
        drop: drop,
        status: "NEW",
        coords: coords,
        pickup: pickUp,
        tripdate: today,
        bookingDate: today,
        reference: reference,
        driver: bookingData.driver || null,
        real_payment_mode: bookingData.payment_mode,
        estimate: bookingData.estimate.estimateFare,
        trip_cost: bookingData.estimate.estimateFare,
        carType: bookingData.carDetails.name || null,
        customer: bookingData.userDetails.uid || null,
        carImage: bookingData.carDetails.image || null,
        estimateTime: bookingData.estimate.estimateTime,
        distance: bookingData.estimate.estimateDistance,
        customer_email: bookingData.userDetails.email || null,
        routeDetails: bookingData.estimate.routeDetails || null,
        estimateDistance: bookingData.estimate.estimateDistance,
        convenience_fees: bookingData.estimate.convenience_fees,
        commission_rate: bookingData.carDetails.convenience_fees,
        booking_type_admin: bookingData.booking_type_admin || null,
        commission_type: bookingData.carDetails.convenience_fee_type,
        passengerBookingLength: bookingData.passengerBookingLength || 0,
        payment_mode: isCashSubPayment ? "cash" : bookingData.payment_mode,
        fleetadmin: bookingData.fleetadmin ? bookingData.fleetadmin : null,
        waypoints: bookingData.drop.waypoints ? bookingData.drop.waypoints : null,
        paymentPacket: bookingData.paymentPacket ? bookingData.paymentPacket : null,
        driverEstimates: bookingData.driverEstimates ? bookingData.driverEstimates : null,
        requestedDrivers: bookingData.requestedDrivers ? bookingData.requestedDrivers : null,
        booking_from_web: bookingData.booking_from_web ? bookingData.booking_from_web : false,
        customer_contact: bookingData.userDetails.mobile ? bookingData.userDetails.mobile : null,
        customer_name: bookingData.userDetails.firstName + ' ' + bookingData.userDetails.lastName,
        customer_token: bookingData.userDetails.pushToken ? bookingData.userDetails.pushToken : null,
        customer_image: bookingData.userDetails.profile_image ? bookingData.userDetails.profile_image : "",
        driver_share: (parseFloat(String(bookingData.estimate.estimateFare)) - parseFloat(String(bookingData.estimate.convenience_fees))).toFixed(settings.decimal),
    }
}


export const clearBooking = () => (dispatch: any) => {
    dispatch({
        type: CLEAR_BOOKING,
        payload: null,
    });
}

export const addBooking = (bookingData: IAddBookingObjType) => async (dispatch: any) => {
    const {
        bookingRef,
        settingsRef,
        singleUserRef
    } = firebase;

    try {

        dispatch({
            type: CONFIRM_BOOKING,
            payload: bookingData,
        });


        const settingsdata = await get(settingsRef);
        const settings = settingsdata.val();

        if (bookingData.requestedDrivers) {
            const drivers = bookingData.requestedDrivers;
            Object.keys(drivers).map((uid) => {
                onValue(singleUserRef(uid), snapshot => {
                    if (snapshot.val()) {
                        const pushToken = snapshot.val().pushToken;
                        const ios = snapshot.val().userPlatform == "IOS" ? true : false
                        if (pushToken) {
                            RequestPushMsg(
                                pushToken,
                                {
                                    ios: ios,
                                    screen: 'DriverTrips',
                                    channelId: settings.CarHornRepeat ? 'bookings-repeat' : 'bookings',
                                    title: store.getState().languagedata.defaultLanguage.notification_title,
                                    msg: store.getState().languagedata.defaultLanguage.new_booking_notification,
                                });
                        }
                    }
                }, { onlyOnce: true });
                return drivers[uid as any];
            })
        }


        let data = await formatBookingObject(bookingData, settings);

        push(bookingRef, data).then((res) => {
            var bookingKey = res.key;
            dispatch({
                type: CONFIRM_BOOKING_SUCCESS,
                payload: {
                    booking_id: bookingKey,
                    mainData: {
                        ...data,
                        id: bookingKey
                    }
                }
            });
        }).catch(error => {
            console.error(error)
            dispatch({
                type: CONFIRM_BOOKING_FAILED,
                payload: error.code + ": " + error.message,
            });
        });
    } catch (error: any) {
        console.error(error)
        dispatch({
            type: CONFIRM_BOOKING_FAILED,
            payload: error.code + ": " + error.message,
        });
    }
};
